import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { RentApplication } from '../../model/rent-application';
import { RentApplicationCommandHandlerResolver } from '../../service/command/rent-application-command-handler-resolver.service';
import { RentApplicationService } from '../../service/data/rent-application.service';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { rentApplicationCommand } from '../../command/rent-application.command';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { RentalObjectCategoryToString, RentalObjectCategory } from '../../model/const/enums';

@Component({
    selector: 'rent-application-manager',
    templateUrl: 'rent-application-manager.component.html',
    styleUrls: ['rent-application-manager.component.scss', './../../../core/component/object-manager/object-manager.template.scss'],
    providers: [RentApplicationCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentApplicationManagerComponent extends MultiselectObjectManagerComponentBase<RentApplication> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: RentApplicationService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: RentApplicationCommandHandlerResolver
  ) {
    super(_dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('RentApplication');
    this.title = 'RENT_APPLICATION.APPLICATION_LIST';
    this.menuDefinition = [new MenuItemDefinition('LEASE_AGREEMENT.COMMAND.EXPORT', rentApplicationCommand.export)];
    this.preferencesKey = 'rent.application-manager.list';
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'RENT_APPLICATION.OBJECT_CATEGORY',
            'rentalObjectCat',
            definition.rentalObjectCat,
            [
              { caption: 'ALL_TEXT', value: 9 },
              { caption: RentalObjectCategoryToString(RentalObjectCategory.Dwelling), value: RentalObjectCategory.Dwelling },
              { caption: RentalObjectCategoryToString(RentalObjectCategory.Parking), value: RentalObjectCategory.Parking },
              { caption: RentalObjectCategoryToString(RentalObjectCategory.Premises), value: RentalObjectCategory.Premises },
              { caption: RentalObjectCategoryToString(RentalObjectCategory.Other), value: RentalObjectCategory.Other },
            ],
            definition.selectedFields.includes('rentalObjectCat')
          ),
          new FilterDefinitionItem('TENANT.NAME', 'name', definition.name, null, definition.selectedFields.includes('name')),
          new FilterDefinitionItem('TENANT.EMAIL', 'email', definition.email, null, definition.selectedFields.includes('email')),
          new FilterDefinitionItem(
            'TENANT.CIVIC_ORG_NUMBER',
            'civicOrOrganizationNo',
            definition.civicOrOrganizationNo,
            null,
            definition.selectedFields.includes('civicOrOrganizationNo')
          ),
        ];
      })
    );

    this.addEditDeleteCommands();
  }
}
